import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TooltipLite from 'react-tooltip-lite';
import { TOOLTIP_DEFAULT_DISTANCE, TOOLTIP_DEFAULT_TEXT_ALIGN, TOOLTIP_DEFAULT_VISIBLE, TOOLTIP_TEXT_ALIGN_DICT } from './Tooltip.constants';
import * as S from './Tooltip.styled';
// Component.
// -----------------------------------------------------------------------------
const Tooltip = ({ content, direction, distance = TOOLTIP_DEFAULT_DISTANCE, textAlign = TOOLTIP_DEFAULT_TEXT_ALIGN, children, visible = TOOLTIP_DEFAULT_VISIBLE }) => {
    if (!content)
        return _jsx(_Fragment, { children: children });
    return (_jsxs(_Fragment, { children: [_jsx(S.TooltipGlobalStyles, {}), _jsx(TooltipLite, { content: content, className: textAlign
                    ? TOOLTIP_TEXT_ALIGN_DICT[textAlign]
                    : `tooltip_${TOOLTIP_DEFAULT_TEXT_ALIGN}`, eventOn: "onFocus", eventOff: "onBlur", padding: 12, arrowSize: 6, tipContentHover: true, direction: direction, distance: distance, tagName: "span", isOpen: visible || undefined, children: children ? children : _jsx(_Fragment, {}) })] }));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map